import RequestService from "./request-service";

export default class AppointmentsService {

  static async getNavbar(returnUrl = "/") {
    const url = "/Home/Navbar";

    return RequestService.get(url, { ReturnUrl: returnUrl });
  }

  static async getNavbarNav(returnUrl = "/") {
    const url = "/Home/NavbarNav";

    return RequestService.get(url, { ReturnUrl: returnUrl });
  }

  static async getTerms() {
    const url = "/Book/Terms";

    return RequestService.get(url);
  }

  static async getAppointments(provider, treatment, start, queryString = "") {
    let url = "/Book/GetAppointments";
    if (queryString !== "") {
      url += `?${queryString}`;
    }

    let startDate = start || new Date();
    startDate = startDate.toISOString();

    return RequestService.get(url, { provider, treatmentId: treatment, start: startDate });
  }

  static setCsrfToken(csrfToken) {
    RequestService.setCsrfTokenIfEmpty(csrfToken);
  }

  static async acceptBookingTerms(appointmentId) {
    const url = "/Book/AcceptTerms";

    return RequestService.post(url, { appointmentId });
  }

  static async beginBooking(appointmentId, bookingNote) {
    const url = "/Book/BeginBooking";

    return RequestService.post(url, { appointmentId, bookingNote });
  }

  static async getPaymentDetails() {
    const url = "/Book/GetPaymentDetails";

    return RequestService.get(url);
  }

  static async confirmAppointment() {
    const url = "/Book/ConfirmAppointment";

    return RequestService.post(url);
  }

  static async sendAppointmentConfirmationEmail(appointmentId) {
    const url = "/Home/SendAppointmentEmail";

    return RequestService.post(
      url,
      { appointmentId }
    );
  }
}
